import { CustomFile } from 'components/upload/type';
import { CourseTypes } from 'config';
import { ListParams } from './common';
import { ICrop } from './crop';

//TODO: fix PHOTO_TYPES after fix PhotoTypes
export enum PhotoTypes {
  MARATHON = 'marathon',
  COURSE = 'course',
  WORKOUT = 'workout',
  COMPLEX = 'complex',
  BROADCAST = 'ether',
  GROUP = 'course-group',
  TRAINER = 'trainer',
  BANNER = 'banner',
  STORY = 'story',
  SOCIAL = 'social',
  DIET = 'diet',
  CHALLENGE = 'challenge',
  TUTORIAL = 'tutorial',
  DIET_GROUP = 'diet-group',
  ACHIEVE = 'achieve',
  PAYWALL = 'paywall',
  GIFT_BOX = 'gift-box',
  WIDGET = 'widget',
  BAD = 'bad',
  NONE = '',
}

export const PhotoTypeNames = {
  [PhotoTypes.COURSE]: 'Курс',
  [PhotoTypes.WORKOUT]: 'Тренировка',
  [PhotoTypes.COMPLEX]: 'Комплекс',
  [PhotoTypes.BROADCAST]: 'Эфир',
  [PhotoTypes.MARATHON]: 'Марафон',
  [PhotoTypes.GROUP]: 'Подборка',
  [PhotoTypes.TRAINER]: 'Тренер',
  [PhotoTypes.BANNER]: 'Баннер',
  [PhotoTypes.STORY]: 'История',
  [PhotoTypes.SOCIAL]: 'Социальные сети',
  [PhotoTypes.DIET]: 'Питание',
  [PhotoTypes.CHALLENGE]: 'Челлендж',
  [PhotoTypes.TUTORIAL]: 'Туториал',
  [PhotoTypes.DIET_GROUP]: 'Подборка питания',
  [PhotoTypes.ACHIEVE]: 'Достижения',
  [PhotoTypes.PAYWALL]: 'Paywall',
  [PhotoTypes.GIFT_BOX]: 'Подарочная коробка',
  [PhotoTypes.WIDGET]: 'Виджет',
  [PhotoTypes.BAD]: 'БАД',
  [PhotoTypes.NONE]: 'Все',
} as const;

export const PhotoTypeCourse = {
  [CourseTypes.COURSE]: PhotoTypes.COURSE,
  [CourseTypes.WORKOUT]: PhotoTypes.WORKOUT,
  [CourseTypes.COMPLEX]: PhotoTypes.COMPLEX,
  [CourseTypes.BROADCAST]: PhotoTypes.BROADCAST,
  [CourseTypes.MARATHON]: PhotoTypes.MARATHON,
  [CourseTypes.CHALLENGE]: PhotoTypes.CHALLENGE,
  [CourseTypes.TUTORIAL]: PhotoTypes.TUTORIAL,
};

//TODO: Fix this after fix PhotoTypes
export const PHOTO_TYPES = [
  { value: PhotoTypes.COURSE, label: PhotoTypeNames[PhotoTypes.COURSE] },
  { value: PhotoTypes.WORKOUT, label: PhotoTypeNames[PhotoTypes.WORKOUT] },
  { value: PhotoTypes.COMPLEX, label: PhotoTypeNames[PhotoTypes.COMPLEX] },
  { value: PhotoTypes.BROADCAST, label: PhotoTypeNames[PhotoTypes.BROADCAST] },
  { value: PhotoTypes.MARATHON, label: PhotoTypeNames[PhotoTypes.MARATHON] },
  { value: PhotoTypes.GROUP, label: PhotoTypeNames[PhotoTypes.GROUP] },
  { value: PhotoTypes.TRAINER, label: PhotoTypeNames[PhotoTypes.TRAINER] },
  { value: PhotoTypes.BANNER, label: PhotoTypeNames[PhotoTypes.BANNER] },
  { value: PhotoTypes.STORY, label: PhotoTypeNames[PhotoTypes.STORY] },
  { value: PhotoTypes.SOCIAL, label: PhotoTypeNames[PhotoTypes.SOCIAL] },
  { value: PhotoTypes.DIET, label: PhotoTypeNames[PhotoTypes.DIET] },
  { value: PhotoTypes.CHALLENGE, label: PhotoTypeNames[PhotoTypes.CHALLENGE] },
  { value: PhotoTypes.TUTORIAL, label: PhotoTypeNames[PhotoTypes.TUTORIAL] },
  { value: PhotoTypes.DIET_GROUP, label: PhotoTypeNames[PhotoTypes.DIET_GROUP] },
  { value: PhotoTypes.ACHIEVE, label: PhotoTypeNames[PhotoTypes.ACHIEVE] },
  { value: PhotoTypes.PAYWALL, label: PhotoTypeNames[PhotoTypes.PAYWALL] },
  { value: PhotoTypes.GIFT_BOX, label: PhotoTypeNames[PhotoTypes.GIFT_BOX] },
  { value: PhotoTypes.WIDGET, label: PhotoTypeNames[PhotoTypes.WIDGET] },
  { value: PhotoTypes.BAD, label: PhotoTypeNames[PhotoTypes.BAD] },
  { value: PhotoTypes.NONE, label: PhotoTypeNames[PhotoTypes.NONE] },
];

export enum ImageFields {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  MOBILE_RECTANGLE = 'mobile_rectangle',
  DESKTOP_RECTANGLE = 'desktop_rectangle',
  COVER = 'cover',
  PHOTO_MOBILE = 'photo_mobile',
  PHOTO_DESKTOP = 'photo_desktop',
  COVER_MOBILE = 'cover_mobile',
  COVER_DESKTOP = 'cover_desktop',
  CARD_COVER_S_VERTICAL = 'card_cover_s_vertical',
  CARD_COVER_S_HORIZONTAL = 'card_cover_s_horizontal',
  CARD_COVER_M_SQUARE = 'card_cover_m_square',
  CARD_COVER_M_RECTANGLE = 'card_cover_m_rectangle',
  CARD_COVER_L_RECTANGLE = 'card_cover_l_rectangle',
  CARD_COVER_DESKTOP = 'card_cover_desktop',
  CARD_COVER = 'card_cover',
  DETAIL_COVER = 'detail_cover',
  DESKTOP_CARD_COVER = 'desktop_card_cover',
  DESKTOP_DETAIL_COVER = 'desktop_detail_cover',
  FEED_AVATAR = 'feed_avatar',
}

export interface ImagePreset {
  width: number;
  height: number;
  title: string;
  rounded?: boolean;
}

export interface Images {
  [ImageFields.MOBILE]: string | null;
  [ImageFields.DESKTOP]: string | null;
}

export type Photo = {
  id: number;
  category: PhotoTypes | null;
  file: CustomFile | string | null;
  or_name: string;
  width: number;
  height: number;
};

export type PhotoBlob = Photo & {
  blob: string | null;
};

export enum WidthTypes {
  WIDTH_TO = 'width_to',
  WIDTH_FROM = 'width_from',
}

export type WidthFromTo = {
  [WidthTypes.WIDTH_FROM]?: string;
  [WidthTypes.WIDTH_TO]?: string;
};

export enum HasMaps {
  NO = 'no',
  YES = 'yes',
  NONE = '',
}

export const MAPS_TYPES = {
  [HasMaps.NO]: 'Нет',
  [HasMaps.YES]: 'Да',
  [HasMaps.NONE]: 'Все',
};

export type PhotoListParams = ListParams & {
  category?: PhotoTypes;
  width?: string;
  maps?: HasMaps;
};

export type PhotoForm = Omit<Photo, 'id' | 'or_name' | 'width' | 'height'>;
export type CreateAvatarForm = { ava: CustomFile | string | null };
export type EditAvatarForm = { ava: string; crop: ICrop };

export const PHOTO_MIN_WIDTH = 0;
export const PHOTO_MAX_WIDTH = 7680;

export enum PhotoPaths {
  IMAGE = 'img',
  AVATAR = 'ava',
}

export interface ImageForCrop {
  orName: string;
  resize: { width: number; height: number } | null;
  orWidth: number;
  orHeight: number;
}

export type ImagesForCrop<T extends ImageFields> = Record<T, ImageForCrop>;

export interface SetImageForCrop<T extends ImageFields> extends ImageForCrop {
  key: T;
}
